import {getMythNFTSConfig, IMythNFTConfig} from "../env";
import {IGraphMythNFT} from "./ResponseBean";
import {getNFTImage} from "../constant/CommonConstant";
import {MythNFTRarity} from "../constant/MythRarity";

export interface IMythNFTMetadata {
    nftTypeId: number,
    name: string,
    rarity: MythNFTRarity,
    quantity: number,
    startTokenId: number
}

export interface IMythNFT {
    tokenId: number,
    noInType: number,
    name: string,
    image: string,
    themeName: string,
    rarity: MythNFTRarity,
    quantity: number,
    noInNFT:number,
    contractAddr:string
}

interface IMythNFTMetadataAndThemeName {
    mythNFTMetadata:IMythNFTMetadata,
    themeName:string,
    imageDir:string
}

function getMythNFTMetadataAndTheme(contractAddr: string, nftTypeId: number): IMythNFTMetadataAndThemeName | undefined {
    const mythNFTSConfig: IMythNFTConfig[] = getMythNFTSConfig();
    const mythNFTConfig = mythNFTSConfig.find(value => {
        return value.theme.contractAddr.toLowerCase() === contractAddr.toLowerCase()
    });
    if (mythNFTConfig) {
        const metadata = mythNFTConfig.metadata.find(value => value.nftTypeId === nftTypeId);
        if(metadata){
            return {mythNFTMetadata:metadata,themeName:mythNFTConfig.theme.name,imageDir:mythNFTConfig.theme.imageDir}
        }
    }
    return undefined;
}

export function convertToMythNFTS(graphMythNFTS: IGraphMythNFT[] | undefined): IMythNFT[] {
    const mythNFTS: IMythNFT[] = [];
    if (graphMythNFTS && graphMythNFTS.length > 0) {
        graphMythNFTS.forEach(value => {
            const mythNFTMetadataAndTheme = getMythNFTMetadataAndTheme(value.tokenAddress, value.nftTypeId);
            if (mythNFTMetadataAndTheme) {
                const noInType = value.tokenId - mythNFTMetadataAndTheme.mythNFTMetadata.startTokenId;
                const image = getNFTImage(mythNFTMetadataAndTheme.imageDir,mythNFTMetadataAndTheme.mythNFTMetadata.nftTypeId);
                const mythNFT: IMythNFT = {
                    tokenId: value.tokenId, noInType: noInType,
                    name: mythNFTMetadataAndTheme.mythNFTMetadata.name, image: image, themeName: mythNFTMetadataAndTheme.themeName,
                    rarity: mythNFTMetadataAndTheme.mythNFTMetadata.rarity, quantity: mythNFTMetadataAndTheme.mythNFTMetadata.quantity,
                    noInNFT:value.tokenId - mythNFTMetadataAndTheme.mythNFTMetadata.startTokenId + 1,
                    contractAddr:value.tokenAddress
                };
                mythNFTS.push(mythNFT);
            }
        });
    }
    return mythNFTS;
}

